export default "__VITE_ASSET__CwCBK8gb__"